import Rete from 'rete'

import { Validator } from './support/validator'

export default class NodeEngine {
  static create(version) {
    return new FlowBuilderEngine(version)
  }
}

class FlowBuilderEngine extends Rete.Engine {
  async validate(data) {
    const checking = Validator.validate(this.id, data)
    
    if (!checking.success)
      return await this.throwError(checking.msg)  
    
    // const recursion = new Rete.Recursion(data.nodes)
    // const recurrentNode = recursion.detect()

    // if (recurrentNode)
    //   return await this.throwError('Recursion detected', recurrentNode)      
     
    return true
  }
}